var map = {
  "./km.json": [
    "916232",
    "321382"
  ],
  "./ru.json": [
    "761666",
    "893283"
  ],
  "./bg.json": [
    "555775",
    "302336"
  ],
  "./el.json": [
    "893903",
    "515106"
  ],
  "./en-pt.json": [
    "544216",
    "240445"
  ],
  "./ja.json": [
    "814251",
    "788502"
  ],
  "./ar.json": [
    "781855",
    "3786"
  ],
  "./rw.json": [
    "9051",
    "915349"
  ],
  "./sr.json": [
    "899976",
    "12111"
  ],
  "./sv.json": [
    "96308",
    "460137"
  ],
  "./fr.json": [
    "494590",
    "921291"
  ],
  "./uk.json": [
    "305483",
    "936835"
  ],
  "./as.json": [
    "125671",
    "25336"
  ],
  "./gu.json": [
    "808286",
    "60147"
  ],
  "./kk.json": [
    "629417",
    "222332"
  ],
  "./nb.json": [
    "409118",
    "364609"
  ],
  "./ta.json": [
    "233419",
    "92124"
  ],
  "./ky.json": [
    "572377",
    "352282"
  ],
  "./pl.json": [
    "37422",
    "15983"
  ],
  "./ro.json": [
    "751210",
    "157455"
  ],
  "./ka.json": [
    "7365",
    "16254"
  ],
  "./hu.json": [
    "545981",
    "199146"
  ],
  "./uz.json": [
    "57790",
    "334032"
  ],
  "./or.json": [
    "385633",
    "433218"
  ],
  "./zh-hans.json": [
    "962568",
    "858159"
  ],
  "./hy.json": [
    "368963",
    "540310"
  ],
  "./de.json": [
    "408990",
    "486836"
  ],
  "./pt-pt.json": [
    "77690",
    "969409"
  ],
  "./vi.json": [
    "399789",
    "511286"
  ],
  "./tr.json": [
    "457071",
    "875123"
  ],
  "./da.json": [
    "224059",
    "469750"
  ],
  "./kn.json": [
    "187033",
    "119637"
  ],
  "./mr.json": [
    "409857",
    "171144"
  ],
  "./id.json": [
    "321232",
    "148489"
  ],
  "./lt.json": [
    "178979",
    "301579"
  ],
  "./lv.json": [
    "170360",
    "429085"
  ],
  "./es.json": [
    "13608",
    "557529"
  ],
  "./ko.json": [
    "218848",
    "615803"
  ],
  "./te.json": [
    "376211",
    "493169"
  ],
  "./bn.json": [
    "535209",
    "177235"
  ],
  "./cs.json": [
    "765191",
    "751108"
  ],
  "./boxes.json": [
    "930976",
    "393021"
  ],
  "./my.json": [
    "271811",
    "522884"
  ],
  "./mn.json": [
    "379636",
    "260600"
  ],
  "./sk.json": [
    "744864",
    "806558"
  ],
  "./nl.json": [
    "661125",
    "73266"
  ],
  "./az.json": [
    "487964",
    "908550"
  ],
  "./accents.json": [
    "226238",
    "260954"
  ],
  "./pa.json": [
    "292193",
    "515519"
  ],
  "./pt.json": [
    "121000",
    "859469"
  ],
  "./extra.json": [
    "642560",
    "244416"
  ],
  "./it.json": [
    "418591",
    "655952"
  ],
  "./hi.json": [
    "187522",
    "303015"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 911806;
module.exports = webpackAsyncContext;
